export const CONFIRMATION_TEXT = 'delete';

export const ACCOUNT_DELETION_WARNINGS = [
  'Your account and profile information will be permanently deleted after the 7-day grace period.',
  'You will lose access to all companies, financial data, invoices, purchases, inventory, and reports linked to this account.',
  'Any active subscriptions or paid services may be cancelled and are not refundable after deletion.',
  'You can cancel this request within 7 days. After that, deletion cannot be reversed.',
] as const;
